module.exports = __webpack_public_path__ + "img/njukblack.ee00533d.png";